module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Sun position calculator","latitude":"Latitude","longitude":"Longitude","time":"Time","azimuth":"Azimuth","elevation":"Elevation","degree":"degree"},"ru":{"title":"Калькулятор положения солнца","latitude":"Широта","longitude":"Долгота","time":"Время","azimuth":"Азимут","elevation":"Высота","degree":"градусы"}}')
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/azcalc.vue
// module id = 714
// module chunks = 0